<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('media.edit', { id: vm.$route.params.mediaId })
  }),
  computed: {
    ...mapState('ridersMedia', ['routeKey', 'routes', 'form', 'item']),
    crumbs: vm => [
      { text: vm.$t('riders.title'), to: { name: 'riders.index' } },
      { text: vm.$t('riders.edit', { id: vm.$route.params.riderId }), to: { name: 'riders.edit' } },
      { text: vm.$t('media.title'), to: { name: 'riders.media.index' } },
      { text: vm.$t('media.edit', { id: vm.$route.params.mediaId }) }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('ridersMedia/fetchItem', { route: to })
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('ridersMedia', ['createItem', 'updateItem'])
  }
}
</script>
